import React from 'react';

import OriginActions from './Actions';

const Actions = ({ actions, data, onEdit, onDelete }) => {
  const handleEdit = () => onEdit?.(data);
  const handleDelete = () => onDelete?.(data);

  return (
    <OriginActions
      actions={actions}
      onDelete={handleDelete}
      onEdit={handleEdit}
    />
  );
};

export default Actions;
